import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Enrique Cabello Delgado. All rights reserved.</p>
    </footer>
  );
};

export default Footer; 